// Structure des catégories professionnelles et leurs grades
const CATEGORIES_PROFESSIONNELLES = {
  "Ingénieur-cadre-assimilés": [
    "Ingénieur principal",
    "Ingénieur",
    "Ingénieur adjoint",
    "Cadre supérieur",
    "Cadre",
    "Cadre adjoint"
  ],
  "Agent de maîtrise-Technicien-assimilé": [
    "Agent de maîtrise principal",
    "Agent de maîtrise",
    "Technicien supérieur",
    "Technicien",
    "Technicien adjoint"
  ],
  "Employé": [
    "Employé qualifié",
    "Employé semi-qualifié",
    "Employé non qualifié",
    "Aide employé"
  ],
  "Chauffeur": [
    "Chauffeur poids lourd",
    "Chauffeur léger",
    "Chauffeur livreur"
  ],
  "Ouvrier": [
    "Ouvrier qualifié P1",
    "Ouvrier qualifié P2",
    "Ouvrier qualifié P3",
    "Ouvrier semi-qualifié",
    "Ouvrier non qualifié",
    "Manœuvre"
  ]
};

// Structure complète des salaires catégoriels par secteur d'activité (basé sur la grille 2023)
const GRILLE_SALAIRES_CATEGORIELS = {
  "SECTEUR INDUSTRIEL": {
    "INGENIEURS-CADRES-ASSIMILES": {
      grades: ["1A", "1B", "2A", "2B", "3A", "3B"],
      salaires: {
        "1A": 172911, "1B": 199052, "2A": 209068, "2B": 237269, "3A": 246644, "3B": 369890
      }
    },
    "AGENTS DE MAITRISE-TECHNICIENS-ASSIMILES": {
      grades: ["MNP", "M1", "M2", "M3", "M4", "M5"],
      salaires: {
        "MNP": 118365, "M1": 134263, "M2": 143676, "M3": 171597, "M4": 186689, "M5": 202250
      }
    },
    "EMPLOYES": {
      grades: ["1", "2", "3", "4", "5", "6", "7A", "7B"],
      salaires: {
        "1": 75000, "2": 86319, "3": 86924, "4": 92367, "5": 110185, "6": 124878, "7A": 126187, "7B": 135531
      }
    },
    "CHAUFFEURS": {
      grades: ["Voitures de Tourisme", "Poids lourds 3-5T", "Poids lourds +5T", "Transport en commun"],
      salaires: {
        "Voitures de Tourisme": 78625, "Poids lourds 3-5T": 82665, "Poids lourds +5T": 85671, "Transport en commun": 86299
      }
    },
    "OUVRIERS": {
      grades: ["1", "2", "3A", "3B", "4A", "4B", "5A", "5B", "6A", "6B", "7"],
      salaires: {
        "1": 75000, "2": 77296, "3A": 77738, "3B": 80042, "4A": 80215, "4B": 83180, "5A": 84587, "5B": 86696, "6A": 88452, "6B": 98729, "7": 134589
      }
    }
  },
  "INDUSTRIE DU BOIS": {
    "INGENIEURS-CADRES-ASSIMILES": {
      grades: ["1A", "1B", "2A", "2B", "3A", "3B"],
      salaires: {
        "1A": 171342, "1B": 197245, "2A": 207171, "2B": 235116, "3A": 244405, "3B": 366533
      }
    },
    "AGENTS DE MAITRISE-TECHNICIENS-ASSIMILES": {
      grades: ["MNP", "M1", "M2", "M3", "M4", "M5"],
      salaires: {
        "MNP": 117290, "M1": 133045, "M2": 142372, "M3": 170041, "M4": 184995, "M5": 200414
      }
    },
    "EMPLOYES": {
      grades: ["1", "2", "3", "4", "5", "6", "7A", "7B"],
      salaires: {
        "1": 75000, "2": 83979, "3": 85340, "4": 91528, "5": 109130, "6": 123745, "7A": 125041, "7B": 134301
      }
    },
    "CHAUFFEURS": {
      grades: ["Voitures de Tourisme", "Poids lourds 3-5T", "Poids lourds +5T", "Transport en commun"],
      salaires: {
        "Voitures de Tourisme": 77912, "Poids lourds 3-5T": 81915, "Poids lourds +5T": 84894, "Transport en commun": 86726
      }
    },
    "OUVRIERS": {
      grades: ["1", "2", "3A", "3B", "4A", "4B", "5A", "5B", "6A", "6B", "7"],
      salaires: {
        "1": 75000, "2": 75264, "3A": 75457, "3B": 77168, "4A": 77360, "4B": 81395, "5A": 83340, "5B": 86190, "6A": 88511, "6B": 98553, "7": 133235
      }
    }
  },
  "INDUSTRIE TEXTILE": {
    "INGENIEURS-CADRES-ASSIMILES": {
      grades: ["1A", "1B", "2A", "2B", "3A", "3B"],
      salaires: {
        "1A": 166411, "1B": 191568, "2A": 201207, "2B": 318748, "3A": 237369, "3B": 355981
      }
    },
    "AGENTS DE MAITRISE-TECHNICIENS-ASSIMILES": {
      grades: ["MNP", "M1", "M2", "M3", "M4", "M5"],
      salaires: {
        "MNP": 115019, "M1": 130470, "M2": 139616, "M3": 166748, "M4": 181414, "M5": 196534
      }
    },
    "EMPLOYES": {
      grades: ["1", "2", "3", "4", "5", "6", "7A", "7B"],
      salaires: {
        "1": 75000, "2": 83936, "3": 85296, "4": 91483, "5": 109131, "6": 123684, "7A": 124979, "7B": 134234
      }
    },
    "CHAUFFEURS": {
      grades: ["Voitures de Tourisme", "Poids lourds 3-5T", "Poids lourds +5T", "Transport en commun"],
      salaires: {
        "Voitures de Tourisme": 77873, "Poids lourds 3-5T": 81873, "Poids lourds +5T": 84852, "Transport en commun": 85473
      }
    },
    "OUVRIERS": {
      grades: ["1", "2", "3A", "3B", "4A", "4B", "5A", "5B", "6A", "6B", "7"],
      salaires: {
        "1": 75000, "2": 75151, "3A": 75264, "3B": 76929, "4A": 77155, "4B": 80851, "5A": 82544, "5B": 85394, "6A": 87878, "6B": 97841, "7": 132222
      }
    }
  },
  "COMMERCE": {
    "INGENIEURS-CADRES-ASSIMILES": {
      grades: ["1A", "1B", "2A", "2B", "3A", "3B"],
      salaires: {
        "1A": 170000, "1B": 195000, "2A": 205000, "2B": 232000, "3A": 242000, "3B": 362000
      }
    },
    "AGENTS DE MAITRISE-TECHNICIENS-ASSIMILES": {
      grades: ["MNP", "M1", "M2", "M3", "M4", "M5"],
      salaires: {
        "MNP": 116000, "M1": 131000, "M2": 140000, "M3": 168000, "M4": 183000, "M5": 198000
      }
    },
    "EMPLOYES": {
      grades: ["1", "2", "3", "4", "5", "6", "7A", "7B"],
      salaires: {
        "1": 75000, "2": 84000, "3": 85500, "4": 91000, "5": 108000, "6": 122000, "7A": 124000, "7B": 133000
      }
    },
    "CHAUFFEURS": {
      grades: ["Voitures de Tourisme", "Poids lourds 3-5T", "Poids lourds +5T", "Transport en commun"],
      salaires: {
        "Voitures de Tourisme": 77000, "Poids lourds 3-5T": 81000, "Poids lourds +5T": 84000, "Transport en commun": 85000
      }
    },
    "OUVRIERS": {
      grades: ["1", "2", "3A", "3B", "4A", "4B", "5A", "5B", "6A", "6B", "7"],
      salaires: {
        "1": 75000, "2": 75500, "3A": 76000, "3B": 77500, "4A": 78000, "4B": 81500, "5A": 83000, "5B": 86000, "6A": 88000, "6B": 98000, "7": 132000
      }
    }
  },
  "BUREAU/SERVICES": {
    "INGENIEURS-CADRES-ASSIMILES": {
      grades: ["1A", "1B", "2A", "2B", "3A", "3B"],
      salaires: {
        "1A": 168000, "1B": 193000, "2A": 203000, "2B": 230000, "3A": 240000, "3B": 360000
      }
    },
    "AGENTS DE MAITRISE-TECHNICIENS-ASSIMILES": {
      grades: ["MNP", "M1", "M2", "M3", "M4", "M5"],
      salaires: {
        "MNP": 115000, "M1": 130000, "M2": 139000, "M3": 166000, "M4": 181000, "M5": 196000
      }
    },
    "EMPLOYES": {
      grades: ["1", "2", "3", "4", "5", "6", "7A", "7B"],
      salaires: {
        "1": 75000, "2": 83500, "3": 85000, "4": 90500, "5": 107500, "6": 121500, "7A": 123500, "7B": 132500
      }
    },
    "CHAUFFEURS": {
      grades: ["Voitures de Tourisme", "Poids lourds 3-5T", "Poids lourds +5T", "Transport en commun"],
      salaires: {
        "Voitures de Tourisme": 76500, "Poids lourds 3-5T": 80500, "Poids lourds +5T": 83500, "Transport en commun": 84500
      }
    },
    "OUVRIERS": {
      grades: ["1", "2", "3A", "3B", "4A", "4B", "5A", "5B", "6A", "6B", "7"],
      salaires: {
        "1": 75000, "2": 75200, "3A": 75700, "3B": 77200, "4A": 77700, "4B": 81200, "5A": 82700, "5B": 85700, "6A": 87700, "6B": 97700, "7": 131700
      }
    }
  }
};

// Fonction pour obtenir le salaire catégoriel basé sur le secteur, la catégorie et le grade
const getSalaireCategoriel = (secteur, categorie, grade) => {
  if (!secteur || !categorie || !grade) return 0;
  const secteurData = GRILLE_SALAIRES_CATEGORIELS[secteur];
  if (!secteurData) return 0;
  const categorieData = secteurData[categorie];
  if (!categorieData) return 0;
  return categorieData.salaires[grade] || 0;
};

export { CATEGORIES_PROFESSIONNELLES, GRILLE_SALAIRES_CATEGORIELS, getSalaireCategoriel };
